export enum SearchParamsEnum {
  contest = 'contest',
  week = 'week',
  token = 'token',
  lang = 'lang',
  clientToken = 'olybetToken',
}
